import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="overflow-hidden">
      {/* Hero */}
      <section className="relative">
        <div className="max-w-6xl mx-auto px-4 md:px-6 pt-10 md:pt-20 pb-16 md:pb-28">
          <div className="eyebrow text-brand mb-6 reveal reveal-1">Rugby Football Club · A side · B side · Socials</div>
          <h1 className="display-xl max-w-5xl reveal reveal-2">
            Played in the <em className="italic font-normal text-brand">mud</em>,
            <br className="hidden sm:block" /> celebrated in the clubhouse.
          </h1>
          <div className="mt-10 md:mt-14 flex flex-col sm:flex-row gap-3 reveal reveal-3">
            <Link to="/join" className="btn-primary h-12 px-6 text-base">
              Join the club
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3 7h8m0 0L7 3m4 4l-4 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
              </svg>
            </Link>
            <Link to="/schedule" className="btn-outline h-12 px-6 text-base">
              See the schedule
            </Link>
          </div>

          {/* Stat band */}
          <div className="mt-20 md:mt-28 grid grid-cols-3 gap-6 md:gap-10 pt-8 border-t border-line reveal reveal-4">
            {[
              { n: '4', l: 'Sides fielded' },
              { n: '32', l: 'Match days / year' },
              { n: '1', l: 'Clubhouse. Yours to rent.' },
            ].map((s) => (
              <div key={s.l}>
                <div className="numeric text-5xl md:text-7xl text-ink leading-none">{s.n}</div>
                <div className="text-xs md:text-sm text-ink-2 mt-3 max-w-[14ch]">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Three pillars */}
      <section className="border-t border-line bg-paper">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-16 md:py-24">
          <div className="eyebrow mb-3">What we do</div>
          <h2 className="display-lg mb-12 md:mb-16 max-w-2xl">
            A club that takes the sport — and the <em className="italic text-brand font-normal">third half</em> — seriously.
          </h2>
          <div className="grid md:grid-cols-3 gap-px bg-line -mx-4 md:mx-0 md:rounded-lg md:overflow-hidden md:border md:border-line">
            {[
              {
                n: '01',
                t: 'Train & play',
                d: 'A and B sides train twice weekly. New players welcome at any level. We coach fundamentals hard.',
                cta: { to: '/join', label: 'Try out' },
              },
              {
                n: '02',
                t: 'Rent the clubhouse',
                d: 'Birthdays, wakes, watch-alongs, weddings. The clubhouse sleeps nobody but holds 120.',
                cta: { to: '/rent', label: 'Enquire' },
              },
              {
                n: '03',
                t: 'Back the club',
                d: 'Buy kit, grab match tickets, or pay seasonal dues. Every pound stays on the pitch.',
                cta: { to: '/shop', label: 'Visit shop' },
              },
            ].map((c) => (
              <div key={c.n} className="bg-paper p-8 md:p-10 flex flex-col">
                <div className="flex items-start justify-between mb-6">
                  <span className="eyebrow text-brand">{c.n}</span>
                  <div className="w-8 h-px bg-line mt-2" />
                </div>
                <h3 className="font-display text-2xl md:text-3xl leading-tight mb-3">{c.t}</h3>
                <p className="text-ink-2 text-sm leading-relaxed flex-1">{c.d}</p>
                <Link
                  to={c.cta.to}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-ink group"
                >
                  {c.cta.label}
                  <span className="transition-transform group-hover:translate-x-0.5">→</span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Editorial quote */}
      <section className="border-t border-line">
        <div className="max-w-4xl mx-auto px-4 md:px-6 py-20 md:py-32 text-center">
          <div className="eyebrow text-brand mb-6">The ethos</div>
          <blockquote className="font-display text-3xl md:text-5xl leading-[1.15] text-ink">
            <span className="text-brand/40">“</span>
            We pick the team from what shows up at training. <em className="italic">Everything else</em> is noise.
            <span className="text-brand/40">”</span>
          </blockquote>
          <div className="eyebrow mt-10">— Head of Rugby</div>
        </div>
      </section>

      {/* CTA strip */}
      <section className="border-t border-line bg-ink text-canvas">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-20 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <div className="eyebrow text-accent mb-3">Next training</div>
            <div className="font-display text-4xl md:text-5xl">Tuesday · 19:00</div>
            <div className="text-canvas/60 mt-2 text-sm">Boots and a gum shield. We'll handle the rest.</div>
          </div>
          <Link to="/join" className="btn bg-canvas text-ink hover:bg-canvas/90 h-12 px-6 text-base w-full md:w-auto">
            Sign up to come down
          </Link>
        </div>
      </section>
    </div>
  );
}
